export default "__VITE_ASSET__q9$hChMJ__"